<template>
    <div class="uni-max m-0" style="min-height: 100vh;">
        <div class="progress-bar"><div class="current-progress" :style="cssVars"></div></div>
        <transition name="fade" mode="out-in">
            <div key=1 v-if="step == 1" class="p-4 uni-max-xs mb-5">
                <div v-if="errors != 'null'" class="notice-error">{{ errors }}</div>
                <div v-else-if="notice != 'null'" class="notice-success">{{ notice }}</div>
                <div class="general-text-3">Step 1 / 3</div>
                <div class="general-text-2 pt-2 pb-4">How can we help you?</div>
                <div class="flex flex-column">
                    <button @click="ltype='sale'; step=2;" class="contact-tab-label h-auto mx-0 w-100 mb-3">Sell Your Property</button>
                    <button @click="ltype='rent'; step=2;" class="contact-tab-label h-auto mx-0 w-100 mb-3">Rent Out Your Property</button>
                    <button @click="ltype='auction'; step=2;" class="contact-tab-label h-auto mx-0 w-100 mb-3">Auction</button>
                </div>
            </div>
            <div key=2 v-else-if="step == 2"  class="p-4 uni-max-xs mb-5">
                <div class="general-text-3">Step 2 / 3</div>
                <div class="general-text-2 pt-2 pb-4">Which property do you want us to {{ ltype }}?</div>
                <div class="form-container-contact">
                    <label for="file-upload">Property Image</label>
                    <label v-if="image != null" for="file-upload" class="image-label pb-3">Change photo</label>
                    <img v-if="image != null" :src="image" width="100%">
                    <label v-if="image == null" for="file-upload" class="mt-0 custom-file-upload justify-content-center" style="height: 180px;">Upload your property image here</label>
                    <input type="file" id="file-upload" name="enquiry[enquiry_listing_attributes][property_image]" accept="image/*" @change="selectImage">

                    <label for="address1">Property Address</label>
                    <input type="text" v-model="address" name="enquiry[enquiry_listing_attributes][property_address1]" placeholder="Unit number, Street Name" required>

                    <div class="row p-0">
                        <div class="col-6 pr-1">
                            <label for="postcode">Postcode</label>
                            <input type="number" v-model="postcode" name="enquiry[enquiry_listing_attributes][postcode]" placeholder="E.g: 12300" required>
                        </div>
                        <div class="col-6 pl-1">
                            <label for="state">State</label>
                            <input type="text" v-model="state" name="enquiry[enquiry_listing_attributes][state]" placeholder="E.g: Penang" required>
                        </div>
                    </div>

                    <label>Property Price</label>
                    <div class="position-relative">
                        <input type="number" v-model="price" name="enquiry[enquiry_listing_attributes][price]" style="padding-left: 45px;" required>
                        <span class="rm-tag">RM</span>
                    </div>

                    <button @click="checkandNext" type="submit" class="btn contact-submit-btn mx-0">Continue to last step</button>
                    <div @click="step = 1" type="submit" class="btn m-0" style="background: none;">Back to previous step</div>
                </div>
            </div>
            <div key=3 v-else-if="step == 3"  class="p-4 uni-max-xs mb-5">
                <div class="general-text-3">Step 3 / 3</div>
                <div class="general-text-2 pt-2 pb-4">How can we contact you?</div>
                <form action="/enquiries" method="post" enctype="multipart/form-data" class="form-container-contact">
                    <label for="name">Your Name</label>
                    <input type="text" name="enquiry[name]" required>

                    <label for="email">Your Email Address</label>
                    <input type="email" name="enquiry[email]" required>

                    <label for="phone">Your Phone Number</label>
                    <input type="tel" name="enquiry[contact_number]" required>

                    <label for="company">Company Name</label>
                    <input type="text" name="enquiry[company_name]">

                    <label for="remark">Remarks</label>
                    <textarea type="text" name="enquiry[message]" rows="5"></textarea>

                    <input type="hidden" name="enquiry[enquiry_listing_attributes][property_image]" :value="image_file">
                    <input type="hidden" name="enquiry[enquiry_listing_attributes][price]" :value="price">
                    <input type="hidden" name="enquiry[enquiry_listing_attributes][state]" :value="state">
                    <input type="hidden" name="enquiry[enquiry_listing_attributes][postcode]" :value="postcode">
                    <input type="hidden" name="enquiry[enquiry_listing_attributes][property_address1]" :value="address">
                    <input type="hidden" name="enquiry[enquiry_listing_attributes][listing_type]" :value="ltype">
                    <input type="hidden" name="enquiry[enquiry_type]" value="SUBMIT_LISTING">
                    <input type="hidden" name="authenticity_token" :value="authtoken">
                    <div class="w-100 px-3">
                        <re-captcha :recaptcha_sitekey="recaptcha_sitekey">
                            <button type="submit" class="btn contact-submit-btn mx-0">Submit your listing</button>
                        </re-captcha>
                    </div>
                    <div @click="step = 2" type="submit" class="btn m-0" style="background: none;">Back to previous step</div>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "list-property",
        props:['authtoken', 'errors', 'notice', 'recaptcha_sitekey'],
        data() {
            return {
                step: 0,
                ltype: '',
                image: null,
                image_file: null,
                address: '',
                postcode: '',
                state: '',
                price: '',
            };
        },
        computed: {
            cssVars() {
                return {
                    '--progress': (this.step/3 * 100) + '%',
                }
            }
        },
        mounted() {
            this.step = 1;
        },
        methods: {
            addComma: function(num) {
                var num_parts = num.toString().split(".");
                num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return num_parts.join(".");
            },
            selectImage(e) {
                const file = e.target.files[0];
                this.image = file ? URL.createObjectURL(file) : (this.image ? this.image : null);
            
                // reCreate new Object and set File Data into it
                var newObject  = {
                    'lastModified': file.lastModified,
                    'lastModifiedDate': file.lastModifiedDate,
                    'name': file.name,
                    'size': file.size,
                    'type': file.type
                };  
                
                this.image_file = JSON.stringify(newObject)
                console.log(JSON.stringify(newObject))
            },
            checkandNext: function() {
                if (this.image && this.ltype && this.address && this.postcode && this.state && this.price) {
                    this.step = 3;
                } else {
                    alert('Please fill in all the fields')
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
.progress-bar{
    width:100%;
    height: 3px;
    background: none;
    position: sticky;
    position: -webkit-sticky;
    top: 60px;
    left: 0;

    .current-progress {
        transition: 0.3s all;
        width: var(--progress);
        height: 3px;
        background: var(--p4redsurface1, #D80000);
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.image-label {
  font-weight: bold;
  display: inline-block;
  text-align: left;
  padding: 0;
  color: #ECBC7B;
}

.rm-tag {
    position:absolute;
    top:15px;
    left:15px;
    font-size: 14px;
    color: var(--p4text1, #FFFFFF);
}

@media (max-width: 991px) {
    .progress-bar{
        top: 72px;
    }
}
</style>